<mds-icon-button class="ag-icon-button" [icon]="params.icon" [tooltip]="''" (clickEvent)="click()" />
